import React from 'react';
import Devices, { defaultConfigComponent as DeviceConfig } from './Devices';
import { IConfigComponent } from '@ts/ui-models';

export const defaultConfigComponent = (): IConfigComponent => {
  return {
    ...DeviceConfig(),
    componentId: 'devicesPhysical',
    filtersFetchData: {
      device: { isAlive: true },
      deviceType: { isAlive: true },
      deviceTypeCategories: { isAlive: true },
      category: { isAlive: true, logicalId: 'physical' },
    },
  };
};
const DevicesPhysical = props => {
  const defaultProps = {
    title: 'Physical devices',
  };

  return <Devices configComponent={defaultConfigComponent()} {...defaultProps} {...props} />;
};

export default DevicesPhysical;
